"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const useWarning_1 = require("../../hooks/useWarning");
const Target_1 = require("../Target");
const Button = (props) => {
    const { warnDeprecation } = (0, useWarning_1.useWarning)();
    const { disabled = false, variant = "primary", size = "medium", download = false, external = false, icon, iconPosition = "start", sx = {}, children } = props, restProps = __rest(props, ["disabled", "variant", "size", "download", "external", "icon", "iconPosition", "sx", "children"]);
    if (iconPosition === "left" || iconPosition === "right") {
        warnDeprecation("The 'left' and 'right' `iconPosition` is deprecated and will be removed in future versions. Please use 'start' and 'end' instead.");
    }
    const iconStart = react_1.default.useMemo(() => iconPosition === "left" || iconPosition === "start", [iconPosition]);
    const iconEnd = react_1.default.useMemo(() => iconPosition === "right" || iconPosition === "end", [iconPosition]);
    const consumerStyles = {
        marginInlineStart: sx.marginInlineStart,
        marginInlineEnd: sx.marginInlineEnd,
        mx: sx.mx,
        my: sx.my
    };
    const layoutStyles = {
        paddingX: size === "small" ? 6 : 8,
        paddingY: 4,
        justifyContent: "center",
        alignItems: "center",
        display: "inline-flex",
        gap: 3
    };
    const appearanceStyles = {
        fontSize: size === "small" ? 1 : 2,
        fontWeight: "bold",
        borderRadius: "buttonBorderRadius",
        borderWidth: 1,
        borderStyle: "solid",
        transition: "colorMedium"
    };
    const primaryVariantStyles = react_1.default.useMemo(() => ({
        backgroundColor: "buttonBackgroundColorPrimary",
        borderColor: "buttonBorderColorPrimary",
        color: "buttonColorPrimary",
        height: size === "small" ? 12 : 14,
        ":hover": {
            backgroundColor: "buttonHoverBackgroundColorPrimary",
            borderColor: "buttonHoverBorderColorPrimary",
            color: "buttonHoverColorPrimary"
        },
        ":active": {
            backgroundColor: "buttonActiveBackgroundColorPrimary",
            borderColor: "buttonActiveBorderColorPrimary",
            color: "buttonActiveColorPrimary"
        },
        ":focus-visible": {
            borderColor: "buttonFocusBorderColorPrimary"
        }
    }), [size]);
    const secondaryVariantStyles = react_1.default.useMemo(() => ({
        backgroundColor: "buttonBackgroundColorSecondary",
        borderColor: "buttonBorderColorSecondary",
        color: "buttonColorSecondary",
        height: size === "small" ? 12 : 14,
        ":hover": {
            backgroundColor: "buttonHoverBackgroundColorSecondary",
            borderColor: "buttonHoverBorderColorSecondary",
            color: "buttonHoverColorSecondary"
        },
        ":active": {
            backgroundColor: "buttonActiveBackgroundColorSecondary",
            borderColor: "buttonActiveBorderColorSecondary",
            color: "buttonActiveColorSecondary"
        },
        ":focus-visible": {
            borderColor: "buttonFocusBorderColorSecondary"
        }
    }), [size]);
    const tertiaryVariantStyles = react_1.default.useMemo(() => ({
        height: size === "small" ? 8 : 10,
        color: "buttonColorTertiary",
        backgroundColor: "transparent",
        borderColor: "transparent",
        paddingX: 2,
        paddingY: 1,
        textDecoration: "underline",
        textDecorationColor: "transparent",
        ":hover": {
            textDecorationColor: "inherit"
        },
        ":active": {
            textDecorationColor: "inherit"
        },
        ":focus-visible": {
            borderColor: "buttonFocusBorderColorTertiary"
        }
    }), [size]);
    const disabledStyles = react_1.default.useMemo(() => {
        if (disabled) {
            return {
                backgroundColor: "buttonBackgroundColorDisabled",
                borderColor: "buttonBackgroundColorDisabled",
                ":hover": {
                    backgroundColor: "buttonBackgroundColorDisabled"
                },
                ":active": {
                    backgroundColor: "buttonBackgroundColorDisabled"
                },
                ":focus-visible": {
                    backgroundColor: "buttonBackgroundColorDisabled"
                }
            };
        }
        else {
            return {};
        }
    }, [disabled]);
    const variantStyles = react_1.default.useMemo(() => {
        let style;
        switch (variant) {
            case "primary":
                style = primaryVariantStyles;
                break;
            case "secondary":
                style = secondaryVariantStyles;
                break;
            case "tertiary":
                style = tertiaryVariantStyles;
                break;
        }
        return Object.assign({}, style);
    }, [
        variant,
        secondaryVariantStyles,
        primaryVariantStyles,
        tertiaryVariantStyles
    ]);
    const renderIcon = () => {
        if (icon) {
            if (Object.values(foundations_1.IconName).includes(icon)) {
                return (react_1.default.createElement(foundations_1.Icon, { icon: icon, size: size === "small" ? "sm" : "base" }));
            }
            else if (Object.values(foundations_1.FlagIconName).includes(icon)) {
                return (react_1.default.createElement(foundations_1.FlagIcon, { icon: icon, size: size === "small" ? "sm" : "base" }));
            }
        }
        return null;
    };
    return (react_1.default.createElement(Target_1.Target, Object.assign({ sx: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, layoutStyles), appearanceStyles), variantStyles), disabledStyles), consumerStyles), disabled: disabled, download: download }, restProps),
        iconStart && renderIcon(),
        children,
        iconEnd && renderIcon(),
        (download || external) && (react_1.default.createElement(foundations_1.Icon, { icon: download ? "arrow-line-down" : "arrow-up-right", size: size === "small" ? "sm" : "base" }))));
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map